import { beginCalendarOAuth } from "../../../apps/shared/calendarOAuth";
export class GoogleCalendarService {
    constructor() {
        this.clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
        this.redirectUri = process.env.REACT_APP_GOOGLE_REDIRECT_URI;
    }

    getAuthUrl(redirectUriOverride = "", context = {}) {
        const scope = 'https://www.googleapis.com/auth/calendar.readonly';
        const clientId = String(this.clientId || '').trim();
        const redirectUri = String(redirectUriOverride || this.redirectUri || '').trim();
        if (!clientId || clientId === 'undefined' || clientId === 'null') {
            throw new Error('Google Calendar sync is not configured: the Google client ID is missing.');
        }
        if (!redirectUri || redirectUri === 'undefined' || redirectUri === 'null') {
            throw new Error('Google Calendar sync is not configured: the Google callback URL is missing.');
        }
        const state = beginCalendarOAuth(window.location.origin, window.localStorage, window.crypto, Date.now(), { returnPath: window.location.pathname + window.location.search, ...context });
        return `https://accounts.google.com/o/oauth2/v2/auth?` +
            `client_id=${encodeURIComponent(clientId)}` +
            `&redirect_uri=${encodeURIComponent(redirectUri)}` +
            `&response_type=code` +
            `&scope=${encodeURIComponent(scope)}` +
            `&access_type=offline` +
            `&include_granted_scopes=true` +
            `&prompt=consent&state=${encodeURIComponent(state)}`;
    }

    async getEvents(accessToken, timeMin, timeMax) {
        try {
            const response = await fetch(
                `https://www.googleapis.com/calendar/v3/calendars/primary/events?` +
                `timeMin=${timeMin.toISOString()}` +
                `&timeMax=${timeMax.toISOString()}` +
                `&singleEvents=true` +
                `&orderBy=startTime`,
                {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (!response.ok) {
                throw new Error('Failed to connect to calendar services');
            }

            const data = await response.json();
            return data.items;
        } catch (error) {
            console.error('Error fetching Google Calendar events:', error);
            throw error;
        }
    }
} 
